/** @format */

import React, { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Maxfiylik siyosati";
  }, []);

  return (
    <>
      <style>{`
        :root { --bg: #fafafa; --card: #fff; --text: #1b1b1b; --muted: #555; --accent: #0b57d0; }
        body { margin: 0; font-family: -apple-system, Segoe UI, Roboto, Arial, sans-serif; }
        .pp-wrapper { background: var(--bg); color: var(--text); min-height: 100vh; padding: 32px 20px; display: flex; justify-content: center; }
        .container { max-width: 900px; width: 100%; }
        header { margin-bottom: 24px; }
        h1 { font-size: 28px; margin: 0 0 8px; }
        .muted { color: var(--muted); font-size: 14px; }
        h2 { margin-top: 28px; font-size: 20px; }
        section { background: var(--card); border: 1px solid #eee; padding: 18px 16px; border-radius: 12px; margin-bottom: 14px; }
        a { color: var(--accent); text-decoration: none; }
        a:hover { text-decoration: underline; }
        ul { margin: 8px 0 0 20px; }
        .footer { margin-top: 28px; font-size: 13px; color: #666; }
        @media (max-width: 520px) {
          .container { padding: 0 8px; }
          h1 { font-size: 22px; }
          h2 { font-size: 18px; }
        }
      `}</style>

      <div className='pp-wrapper'>
        <div className='container' role='main'>
          <header>
            <h1>Maxfiylik siyosati</h1>
            <div className='muted'>Kuchga kirgan sana: 2025-09-16</div>
          </header>

          <section>
            <h2>1. Umumiy maʼlumot</h2>
            <p>
              Ushbu mobil ilova Oʻzbekiston Respublikasi Suv xoʻjaligi
              vazirligining tizim tashkilotlarida ishlovchi xodimlar uchun
              ishlab chiqilgan. Maʼlumotlar xavfsizligi va uchinchi tomon
              ilovalari orqali yuzaga kelishi mumkin boʻlgan xatarlarning oldini
              olish maqsadida, ilova rasmiy <strong>Google Play</strong> va{" "}
              <strong>Apple App Store</strong>
              doʻkonlari orqali tarqatiladi.
            </p>
          </section>

          <section>
            <h2>2. Qamrov</h2>
            <p>
              Ushbu siyosat ilovadan foydalanganingizda maʼlumotlar bilan
              ishlash tartibini tushuntiradi. Agar siz rasmiy doʻkonlardan
              tashqari manbalardan yuklab olingan ilovadan foydalansangiz, bu
              siyosat bunday holatlarga tatbiq etilmaydi.
            </p>
          </section>

          <section>
            <h2>3. Maʼlumotlarni yigʻish</h2>
            <p>
              <strong>
                Ilova foydalanuvchilardan shaxsiy maʼlumotlarni yigʻmaydi,
                saqlamaydi va uchinchi shaxslarga uzatmaydi.
              </strong>
            </p>
            <p>
              Ilova faqat tizimdagi mavjud xizmatlar (masalan, API yoki
              korporativ maʼlumotlar bazasi) bilan bogʻlanadi va maʼlumotlarni{" "}
              <em>oʻqish</em> rejimida, <em>rol va ruxsatlar</em> asosida
              ko‘rsatadi.
            </p>
          </section>

          <section>
            <h2>4. Maʼlumotlarni qayta ishlash va rollar</h2>
            <ul>
              <li>
                Ilova foydalanuvchining lavozimi va berilgan ruxsatlariga mos
                ravishda maʼlumotlarni taqdim etadi.
              </li>
              <li>
                Ilovada foydalanuvchi yaratgan, tahrirlagan yoki yuklagan
                maʼlumotlar (agar bunday funksiyalar mavjud boʻlsa) tegishli
                tashkilot infratuzilmasida saqlanadi.
              </li>
              <li>
                Ilova offlayn rejimda shaxsiy maʼlumotlarni keshda saqlamaydi
                (faqat texnik seans maʼlumotlari, zarur boʻlsa – qurilmada
                vaqtincha).
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Uchinchi tomon xizmatlari</h2>
            <p>
              Ilova tarkibida foydalanuvchi maʼlumotlarini yigʻlaydigan uchinchi
              tomon SDK yoki reklama modullari ishlatilmaydi. Doʻkonlar
              (Google/Apple) tomonidan yigʻilishi mumkin boʻlgan diagnostika va
              doʻkon darajasidagi maʼlumotlar ularning maxfiylik siyosatlari
              bilan tartibga solinadi.
            </p>
          </section>

          <section>
            <h2>6. Xavfsizlik</h2>
            <ul>
              <li>
                Tarmoq orqali uzatiladigan maʼlumotlar himoyalangan kanallar
                (HTTPS/TLS) orqali yuboriladi.
              </li>
              <li>
                Foydalanuvchi identifikatsiyasi (agar mavjud boʻlsa)
                tashkilotning amaldagi autentifikatsiya tizimi orqali amalga
                oshiriladi.
              </li>
              <li>
                Ilova ruxsatlari minimal zarurat tamoyili asosida soʻraladi.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Bolalar maxfiyligi</h2>
            <p>
              Ilova faol xodimlarga moʻljallangan. Bolalarga moʻljallangan
              xizmatlarni oʻz ichiga olmaydi va bolalardan maʼlumot yigʻmaydi.
            </p>
          </section>

          <section>
            <h2>8. Siyosatga oʻzgartirishlar</h2>
            <p>
              Zarurat tug‘ilganda ushbu siyosat yangilanishi mumkin. Eng so‘nggi
              versiya doimo ushbu sahifada eʼlon qilinadi.
            </p>
          </section>

          <section>
            <h2>9. Bogʻlanish</h2>
            <p>
              Savollar boʻlsa, ilova ishlab chiquvchisiga yoki tegishli
              tashkilotga murojaat qiling:
              <a href='mailto:suvitraqamlashtirish@gmail.com'> suvitraqamlashtirish@gmail.com</a>
            </p>
          </section>

          <div className='footer'>
            &copy; 2025 Suv xoʻjaligi vazirligi tizim tashkilotlari uchun ishlab
            chiqilgan ilova.
          </div>
        </div>
      </div>
    </>
  );
}
